module.exports = __webpack_public_path__ + "img/cases-brand-chinamobile-lazyload-04.cf0acdcc.jpg";